export default "__VITE_ASSET__3f74f3f7__"